module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-6f10ebcd.svg";